import React from 'react'
import Modal from 'react-bootstrap/lib/Modal'
class ModalChecklist extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            zoom: 1,
            rotation: 0,
            translateX: 0,
            translateY: 0,
            dragging: false,
            startX: 0,
            startY: 0
        }
    }
    componentDidMount() {
        this.props.checklist(this.props.idInventario)
    }
    /* ================= ZOOM (SOLO BOTONES) ================= */
    zoomIn = () => {
        this.setState({
            zoom: Math.min(3, this.state.zoom + 0.2)
        })
    }
    zoomOut = () => {
        if (this.state.zoom <= 1.2) {
            this.resetView()
        } else {
            this.setState({
                zoom: this.state.zoom - 0.2
            })
        }
    }
    resetView = () => {
        this.setState({
            zoom: 1,
            translateX: 0,
            translateY: 0
        })
    }
    /* ================= ROTACIÓN (SIN CORTE) ================= */
    rotateLeft = () => {
        this.setState({
            rotation: this.state.rotation - 90,
            zoom: 1,
            translateX: 0,
            translateY: 0
        })
    }
    rotateRight = () => {
        this.setState({
            rotation: this.state.rotation + 90,
            zoom: 1,
            translateX: 0,
            translateY: 0
        })
    }
    /* ================= DRAG ================= */
    handleMouseDown = (e) => {
        if (this.state.zoom === 1) return
        this.setState({
            dragging: true,
            startX: e.clientX,
            startY: e.clientY
        })
    }
    handleMouseMove = (e) => {
        if (!this.state.dragging) return
        const dx = e.clientX - this.state.startX
        const dy = e.clientY - this.state.startY
        this.setState({
            translateX: this.state.translateX + dx,
            translateY: this.state.translateY + dy,
            startX: e.clientX,
            startY: e.clientY
        })
    }
    handleMouseUp = () => {
        this.setState({ dragging: false })
    }
    render() {
        const indicator = this.props.id_file.find(
            (ind) => ind.inv == this.props.idInventario
        )
        return (
            <Modal
                show={this.props.showModal}
                onHide={this.props.cancelModal}
                bsSize="large"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Checklist Inventario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* CONTENEDOR SIN SCROLL */}
                    <div
                        style={{
                            width: '100%',
                            height: '70vh',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f5f5f5',
                            overflow: 'hidden',
                            cursor: this.state.zoom > 1 ? 'grab' : 'default'
                        }}
                        onMouseMove={this.handleMouseMove}
                        onMouseUp={this.handleMouseUp}
                        onMouseLeave={this.handleMouseUp}
                    >
                        <img
                            src={this.props.indicators}
                            alt="Checklist"
                            onMouseDown={this.handleMouseDown}
                            draggable={false}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '100%',
                                objectFit: 'contain',
                                transform:
                                    'translate(' +
                                    this.state.translateX +
                                    'px, ' +
                                    this.state.translateY +
                                    'px) ' +
                                    'scale(' +
                                    this.state.zoom +
                                    ') rotate(' +
                                    this.state.rotation +
                                    'deg)',
                                transformOrigin: 'center center',
                                transition: this.state.dragging
                                    ? 'none'
                                    : 'transform 0.25s ease'
                            }}
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-default" onClick={this.rotateLeft}>
                        Girar ⟲
                    </button>
                    <button className="btn btn-default" onClick={this.rotateRight}>
                        Girar ⟳
                    </button>
                    <button className="btn btn-default" onClick={this.zoomOut}>
                        Zoom -
                    </button>
                    <button className="btn btn-default" onClick={this.zoomIn}>
                        Zoom +
                    </button>
                    {indicator ? (
                        <a
                            className="btn btn-primary"
                            href={`/inventario/archivo-final/${indicator.indicator.id_file}/descargar-checklist`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Descargar Checklist
                        </a>
                    ) : null}
                </Modal.Footer>
            </Modal>
        )
    }
}

export default ModalChecklist



// WEBPACK FOOTER //
// ./frontEnd/home/components/ModalChecklist.jsx